import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Items, ItemChoice } from '../model/items';
import { Router, NavigationExtras } from '@angular/router';
import { EmailService } from '../services/email.service';
import { AngularFireFunctions } from '@angular/fire/functions';
import { OrderHelper } from '../helpers/order.helper';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { EmailHelper } from '../helpers/emailHelper';
declare function loadFunctions(): any;

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit {

  @Output() public purchaseOrder = new EventEmitter<any>();
  @ViewChild('file') fileLink: ElementRef;
  @ViewChild('maskImage') maskImage: ElementRef;

  itemsList: Items[];
  purchaseOrderItemsList: Items[] = [];
  selInd: string;
  selectedIndexes: Map<string, string> = new Map<string, string>();
  quantityErrorIndexes: string[] = [];
  subTotalValue: number = 0.00;
  loading: Boolean = false;
  isListValid: Boolean = false;
  totalBoxesSold: number = 0;
  totalDonations: number = 0;
  closeResult: string;
  selectedImage: string;

  constructor(private db: AngularFireDatabase, private firebaseFn: AngularFireFunctions,
    private router: Router, private emailService: EmailService, private modalService: NgbModal) { }

  orderHelper: OrderHelper = new OrderHelper(this.db);
  emailHelper: EmailHelper = new EmailHelper(this.db, this.firebaseFn);

  ngOnInit(): void {
    this.loading = true;
    this.selectedIndexes = new Map<string, string>();
    this.purchaseOrderItemsList = [];
    this.isListValid = false;
    this.subTotalValue = 0.00;
    this.db.list('/items').snapshotChanges().subscribe(
      response => {
        this.itemsList = response.map(c => (
          {
            key: c.payload.key, ...(c.payload.val() as any)
          }
        ));
        loadFunctions();
        this.loading = false;
        /*this.orderHelper.getMPMADonations().then(returnObj => {
          this.totalDonations = returnObj['totalDonations'];
          this.totalBoxesSold = returnObj['totalBoxesSold'];
          this.loading = false;
        });*/
      }, error => {
        this.loading == false;
      }
    )
  }

  setSelectedIndexes(i, j) {
    if (this.selectedIndexes.has(i)) {
      var currentInd = this.selectedIndexes.get(i);
      this.subTotalValue = this.subTotalValue - parseFloat(this.itemsList[i].itemChoices[currentInd].itemChoiceTotalPrice);
      this.itemsList[i].itemChoices[currentInd].itemChoiceQuantity = "";
      this.itemsList[i].itemChoices[currentInd].itemChoiceTotalPrice = "";
      this.itemsList[i].itemChoices[currentInd].isChecked = false;
    }
    this.selectedIndexes.set(i, j);
    this.itemsList[i].itemChoices[j].itemChoiceQuantity = "0";
    this.itemsList[i].itemChoices[j].itemChoiceTotalPrice = "0";
    this.itemsList[i].itemChoices[j].isChecked = true;
    //this.validateList();
  }

  setQuantity(i, j, event) {
    if (this.itemsList[i].itemChoices[j].isChecked) {
      let maxval = this.itemsList[i].itemChoices[j].itemMaxVal;
      let minVal = this.itemsList[i].itemChoices[j].itemMinVal;
      if (event.target.value && event.target.value != '' && event.target.value > 0) {
        let quantity = event.target.value;
        if (parseInt(quantity) >= parseInt(minVal)) {
          if (maxval == "" || (maxval != "" && parseInt(quantity) <= parseInt(maxval))) {
            if (this.quantityErrorIndexes.includes(i)) {
              this.quantityErrorIndexes.splice(this.quantityErrorIndexes.indexOf(i), 1);
            }
            this.subTotalValue = this.subTotalValue - parseFloat(this.itemsList[i].itemChoices[j].itemChoiceTotalPrice);
            this.itemsList[i].itemChoices[j].itemChoiceQuantity = event.target.value;
            let totalPrice = parseFloat(event.target.value) * parseFloat(this.itemsList[i].itemChoices[j].itemChoicePrice);
            this.itemsList[i].itemChoices[j].itemChoiceTotalPrice = totalPrice.toString();
            this.subTotalValue = this.subTotalValue + totalPrice;
          } else {
            if (!this.quantityErrorIndexes.includes(i)) {
              this.quantityErrorIndexes.push(i);
            }
          }
        } else {
          if (!this.quantityErrorIndexes.includes(i)) {
            this.quantityErrorIndexes.push(i);
          }
        }
      }

    }
    //this.validateList();    
  }

  validateList() {
    if (this.selectedIndexes && this.selectedIndexes.size > 0) {
      var invalidQtyCnt = 0;
      this.selectedIndexes.forEach((value, key) => {
        var quantity = this.itemsList[key].itemChoices[value].itemChoiceQuantity;
        if (!quantity || quantity == "") {
          invalidQtyCnt++;
        }
      });
      if (invalidQtyCnt > 0) {
        this.isListValid = false;
      } else {
        this.isListValid = true;
      }
    } else {
      this.isListValid = false;
    }
  }

  confirmOrder() {
    if (this.selectedIndexes && this.selectedIndexes.size > 0) {
      this.selectedIndexes.forEach((value, key) => {
        let item: Items = this.itemsList[key];
        let newItem: Items = new Items(item);
        newItem.itemChoices = [];
        item.itemChoices.forEach(itemChoice => {
          if (itemChoice.isChecked && itemChoice.itemChoiceQuantity != '' && itemChoice.itemChoiceQuantity != '0') {
            newItem.itemChoices.push(itemChoice);
          }
        });
        if (newItem.itemChoices && newItem.itemChoices.length > 0) {
          this.purchaseOrderItemsList.push(newItem);
        }
      });

      if (this.purchaseOrderItemsList.length > 0) {
        const queryParams: any = {};
        queryParams.myArray = JSON.stringify(this.purchaseOrderItemsList);
        queryParams.totalValue = this.subTotalValue;
        const navigationExtras: NavigationExtras = {
          queryParams
        };
        this.router.navigate(['/confirmOrder'], navigationExtras);
        this.purchaseOrder.emit(this.purchaseOrderItemsList);
      }
    }
  }

  cancelOrder() {
    this.ngOnInit();
  }

  openFile(filetype) {
    let filePath = "assets/MASK BFE.pdf";
    if (filetype == 'SBPT') {
      filePath = "assets/MASK SBPT.pdf";
    }
    this.fileLink.nativeElement.href = filePath;
    this.fileLink.nativeElement.click();
  }

  showMaskImage(imagePath) {
    this.selectedImage = imagePath;
    this.openModal(this.maskImage);
  }

  openModal(content) {
    this.modalService.dismissAll();
    this.modalService.open(content, { backdrop: 'static', ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.loading = false;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.loading = false;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  sendEmail() {
    this.emailHelper.sendEmailsAfterOrderId().then(() => {
      console.log("Emails Sent");
    }).catch(error => {
      console.log("Email sent error");
    })
  }
}

